export default __webpack_public_path__ + "static/media/Edition-BxnV.3f4a80c3.ttf";